import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { Router } from '@angular/router';
import { AuthService, UsersService } from 'src/app/api/identity/services';
import { LoginApiResponse, UserProfileDto } from 'src/app/api/identity/models';
import { RedirectService } from 'src/app/shared/services/redirect-service';
import {
  BrandingService,
  BrandProfile,
} from 'src/app/shared/branding/branding.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  public auth!: Observable<any>;
  @HostBinding('class') class = 'w-100';
  readonly brand: BrandProfile;
  public loginForm!: UntypedFormGroup;
  public isAuthLoading = false;
  private loggedInUser: UserProfileDto = {};
  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private redirectService: RedirectService,
    private userService: UsersService,
    branding: BrandingService
  ) {
    this.brand = branding.brand;
  }
  ngOnInit() {
    this.renderer.addClass(document.querySelector('app-root'), 'login-page');
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required),
    });
  }
  fetchLoggedInUser() {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUser = user?.data[0] || {};

          this.redirectService.setPermissions(
            this.loggedInUser.Privileges || []
          );
          const redirectUrl =
            this.redirectService.getRedirectUrl() || '/welcome';
          this.redirectService.clearRedirectUrl();
          this.router.navigateByUrl(redirectUrl);
          this.isAuthLoading = false;
        }
      },
      error: error => {
        this.isAuthLoading = false;
        this.toastr.error(error?.error?.message);
      },
    });
  }

  loginByAuth() {
    if (this.loginForm.valid) {
      this.isAuthLoading = true;
      const payload = {
        body: {
          username: this.loginForm.value.email,
          password: this.loginForm.value.password,
        },
      };
      this.authService.passwordLogin(payload).subscribe(
        (res: LoginApiResponse) => {
          if (res.code === 200) {
            console.log('res', res);

            this.toastr.success(res.message);
            const token = res.data ? (res.data[0].accessToken as string) : '';
            const refresh = res.data
              ? (res.data[0].refreshToken as string)
              : '';

            this.localStorageService.setItem('invoiceToken', token);
            this.localStorageService.setItem('invoiceRefreshToken', refresh);
            this.fetchLoggedInUser();
          }
        },
        error => {
          this.isAuthLoading = false;
          this.loginForm.reset();
          this.toastr.error(error?.error?.message);
        }
      );
    } else {
      this.toastr.error('credentials not found');
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
  }
}
